import { useMediaQuery, useTheme } from '@mui/material'
import { styled } from '@mui/system'
import React from 'react'
import {
  toast,
  Id,
  ToastContainer as ToastifyContainer,
  CloseButtonProps,
  Slide,
} from 'react-toastify'
import { colors } from '../themes/colors'

const StyledCloseButton = styled('div')`
  align-self: center;
`

const CloseButton = ({ closeToast }: CloseButtonProps) => (
  <StyledCloseButton className='material-symbols-outlined' onClick={closeToast}>
    close
  </StyledCloseButton>
)

export const ToastContainer = () => {
  const theme = useTheme()
  const isSm = useMediaQuery(theme.breakpoints.down('sm'))
  const isMd = useMediaQuery(theme.breakpoints.down('md'))
  const toastContainerStyle: React.CSSProperties = {
    width: isSm ? '100%' : '335px',
    top: isMd ? 0 : 'auto',
    padding: isMd ? '16px' : 'auto',
    paddingTop: isMd ? 'calc(16px + var(--safe-area-statusbarHeight))' : 'auto',
  }

  return (
    <ToastifyContainer
      toastStyle={{
        height: '3rem',
        fontFamily: 'Nunito Sans',
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150%',
        borderRadius: '8px',
        background: colors.primary900,
      }}
      style={toastContainerStyle}
      transition={Slide}
      limit={1}
      position={isMd ? 'top-center' : 'bottom-center'}
      autoClose={2000}
      newestOnTop
      hideProgressBar
      closeOnClick
      closeButton={CloseButton}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme='dark'
    />
  )
}

export const useToast = () => {
  const toastId = React.useRef<Id | undefined>(undefined)

  const notify = (msg: string) => {
    dismissAll()
    toastId.current = toast(msg)
  }

  const dismiss = () => toast.dismiss(toastId.current)

  const dismissAll = () => toast.dismiss()

  return {
    notify,
    dismiss,
    dismissAll,
  }
}

export default useToast
